import { TextField, MenuItem } from '@mui/material'
import PropTypes from 'prop-types'

const FieldSelectComponent = ({ value, config={}, events={} }) => {
    const handleChange = (e) => {
        if (events.handleChange)
            events.handleChange(e.target.value)
    }

    const error = config.errors?.[config.name]

    return (
        <TextField
            select
            className="c-FieldSelect"
            label={config.label}
            fullWidth
            size={config.size || 'small'}
            value={value ?? ''}
            onChange={handleChange}
            error={!!error}
            helperText={(error && error[0]) || config.helperText}
        >
            {(config.options || []).map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
            ))}
        </TextField>
    )
}

FieldSelectComponent.propTypes = {
    value: PropTypes.any,

    config: PropTypes.shape({
        name: PropTypes.string,
        label: PropTypes.string,
        helperText: PropTypes.string,
        errors: PropTypes.object,
        size: PropTypes.oneOf(['small', 'medium']),
        options: PropTypes.arrayOf(PropTypes.shape({
            value: PropTypes.any,
            label: PropTypes.string
        }))
    }),

    events: PropTypes.shape({
        handleChange: PropTypes.func
    })
}

export { FieldSelectComponent }
